import { getDefaultModuleConfiguration } from "../../utilities/moduleConfigurationUtils";

const initial_state = {
  ...getDefaultModuleConfiguration(),
  loaded: false,
};

const moduleConfigReducer = (state = initial_state, action) => {
  switch (action.type) {
    case "SET_MODULE_CONFIG": {
      const payload = action.payload || action.moduleConfig || {};
      return {
        ...state,
        ...payload,
        modules: payload.modules || state.modules,
        pages: payload.pages || state.pages || {},
        fieldGroups: payload.fieldGroups || state.fieldGroups || {},
        loaded: true,
      };
    }

    case "MODULE_CONFIG_RESET":
      return {
        ...getDefaultModuleConfiguration(),
        loaded: false,
      };

    default:
      return state;
  }
};

export default moduleConfigReducer;
